import * as api from './api';
import * as MutationTypes from './mutationsTypes';
import { PowerBiParams } from './models/powerBiParams';

export const powerBiParamsRequest = async ({ commit, rootGetters }) => {
  const pogGuid = rootGetters.selectedPointOfSale.guid;
  const response = await api.powerBiParamsRequest(pogGuid);
  const powerBiParams = PowerBiParams.toInstance(response.data);
  commit(MutationTypes.POWER_BI_PARAMS, powerBiParams);
};
